import React, {useEffect, useMemo, useCallback, useState} from 'react';
import {observer} from 'mobx-react';
import {useRouter} from 'next/router';
import {useStore} from '../components/StoreProvider';
import {LoadingState} from '../components/LoadingState/LoadingState';
export {getStaticProps} from '@amplify/abflag';

const IndexPage: React.FC = () => {
    const store = useStore();
    const router = useRouter();
    const [isRedirecting, setIsRedirecting] = useState(false);
    const {route} = store.uiStore.progressStore;
    const queryParamStringify = useMemo(() => {
        if (!router.query || Object.keys(router.query).length === 0) return '';

        try {
            const queryParams = new URLSearchParams(router.query as Record<string, string>);
            const queryString = queryParams.toString();
            return queryString.length > 0 ? `?${queryString}` : '';
        } catch (error) {
            console.warn('Error parsing query parameters:', error);
            return '';
        }
    }, [router.query]);

    const targetRoute = useMemo(() => `${route}${queryParamStringify}`, [route, queryParamStringify]);

    const handleRedirect = useCallback(async () => {
        if (router.pathname === '/' && router.isReady && !isRedirecting) {
            try {
                setIsRedirecting(true);

                if (queryParamStringify.length > 0) {
                    store.uiStore.progressStore.initializeRoute(queryParamStringify);
                }

                const currentPath = router.asPath;
                if (currentPath !== targetRoute) {
                    await router.push(targetRoute);
                }
            } catch (error) {
                console.error('Error during redirect:', error);
                if (router.asPath === '/') {
                    await router.push(route);
                }
            } finally {
                setIsRedirecting(false);
            }
        }
    }, [
        router.pathname,
        router.isReady,
        router.asPath,
        queryParamStringify,
        targetRoute,
        store.uiStore.progressStore,
        router,
        isRedirecting,
        route,
    ]);

    useEffect(() => {
        handleRedirect();
    }, [handleRedirect]);

    return <LoadingState height="100vh" />;
};

export default observer(IndexPage);
